import { render, staticRenderFns } from "./labelmanagetable.vue?vue&type=template&id=cde12212&scoped=true&"
import script from "./labelmanagetable.vue?vue&type=script&lang=js&"
export * from "./labelmanagetable.vue?vue&type=script&lang=js&"
import style0 from "./labelmanagetable.vue?vue&type=style&index=0&id=cde12212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde12212",
  null
  
)

export default component.exports